import { reactive, onBeforeMount } from '@vue/composition-api';
import router from '@/router';

export default function useDataManagementDetail() {
  const queryConfig = reactive({
    queryDataId: null,
    queryDataKey: null, //optional
  });

  const getQueryConfig = () => {
    queryConfig.queryDataId = 3;
    queryConfig.queryDataKey = "Customer_Detail";
  };

  onBeforeMount(() => {
    getQueryConfig();
  });

  return { queryConfig };
}
